import { render, staticRenderFns } from "./EditChallenge.vue?vue&type=template&id=29ec2a44&"
import script from "./EditChallenge.vue?vue&type=script&lang=js&"
export * from "./EditChallenge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports